import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { map, catchError, tap } from 'rxjs/operators';
import { AuthService } from '@core/auth/auth.service';
import { AuthInterceptor } from '@core/http/auth.interceptor';

@Injectable({
  providedIn: 'root',
})
export class ApiSysPermissionService {
  private url;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.url = environment.url_general_api;
  }

  private get authHeaders(): HttpHeaders {
    return new HttpHeaders().set('Authorization', `Bearer ${this.authService.getToken()}`);
  }

  private get layoutRequestContext(): HttpContext {
    return new HttpContext().set(AuthInterceptor.SKIP_AUTH_ERROR_REDIRECT, true);
  }

  getIdPermission(token: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(
      `${this.url}/mongo/modules/ids`,
      { headers }
    ).pipe(
      catchError(error => {
        console.error('Error getting data', error);
        return throwError(() => error);
      })
    );
  }

  getonepermission(token: string, id: number): Observable<any> {
    {
      const headers = this.authHeaders;
      return this.http.get(
        `${this.url}/mongo/permissions/${id}`,
        { headers }
      ).pipe(
        catchError(error => {
          console.error('Error getting data', error);
          return throwError(() => error);
        })
      );
    }
  }
  getownpermission(token: string, id: number, moduleId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(`${this.url}/mongo/ownpermission/${id}`, { headers }).pipe(
      map((permissions: any) => {
        if (!permissions) {
          return null;
        }
        // Extract modules from permissions
        const modules = permissions.modules;

        // Find the module with the given moduleId
        const module = modules.find((perm: any) => perm.module === moduleId);

        // If module is found, return the permissions, otherwise return null
        return module ? module.permissions : null;
      }),
      tap((modulePermissions) => {
        if (!modulePermissions) {
          console.log("User does not have the required permissions for this module.");
        } else {
          console.log("Module permissions:", modulePermissions);
        }
      }),
      catchError(error => {
        console.error('Error getting data', error);
        return throwError(() => error);
      })
    );
  }
  getallownPermission(token: string, id: number): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(`${this.url}/mongo/ownpermission/${id}`, { headers }).pipe(
      catchError(error => {
        console.error('Error getting data', error);
        return throwError(() => error);
      })
    );
  }

  getPermissionsMenu(token: string): Observable<any> {
    const headers = this.authHeaders;

    return this.http.get(`${this.url}/mongo/checkModulesPermission`, {
      headers,
      context: this.layoutRequestContext,
    }).pipe(
      catchError(error => {
        console.error('Error getting module permissions:', error);
        // Aquí puedes personalizar el error si es necesario
        return throwError(() => error);
      })
    );
  }


}
